export default "__VITE_ASSET__DptsphvC__"